// extracted by mini-css-extract-plugin
export default {"productcard":"iH","productimage":"jH","username":"kH","multiBagName":"lH","productinfo":"mH","productinfoinner":"nH","productname":"oH","productsubheader":"pH","productdescription":"qH","productnumbers":"rH","productnumberstitle":"sH","productnumbersitem":"tH","number":"uH","numbertext":"vH","tabs":"wH","benefitsblock":"xH","benefit":"yH","benefitname":"zH","benefitdescription":"AH","ingredientsblock":"BH","tipsblock":"CH","mobileonly":"EH"};
    if(module.hot) {
      // 1711394578662
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  